// removed by extract-text-webpack-plugin
module.exports = {"this":"GroupMessages__this___2g2bh","sidebar":"GroupMessages__sidebar___2NdX-","wrap":"GroupMessages__wrap___3cDpx","content":"GroupMessages__content___2qfvz"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/GroupMessages.css
// module id = 2572
// module chunks = 0 1